import { ReactComponent as AchievementIcon } from "components/Icons/award-01.svg";
import { ReactComponent as CustomEventIcon } from "components/Icons/code-square-01.svg";
import { ReactComponent as InternalEventIcon } from "components/Icons/data.svg";
import { ReactComponent as ReturnTransactionIcon } from "components/Icons/reverse-right.svg";
import { ReactComponent as TransactionIcon } from "components/Icons/shopping-cart-01.svg";
import { ReactComponent as FileIcon } from "components/Icons/sticker-square.svg";
import { CampaignTriggersUnion } from "types/campaigns";
import { CampaignStepsIds } from "./CampaignForm";

export const getTriggerLabelBox = (trigger: CampaignTriggersUnion) => {
  switch (trigger) {
    case "transaction":
      return {
        icon: <TransactionIcon />,
        label: "purchaseTransaction",
      };
    case "return_transaction":
      return {
        icon: <ReturnTransactionIcon />,
        label: "returnTransaction",
      };

    case "internal_event":
      return {
        icon: <InternalEventIcon />,
        label: "internalEvent",
      };
    case "custom_event":
      return {
        icon: <CustomEventIcon />,
        label: "customEvent",
      };
    case "achievement":
      return {
        icon: <AchievementIcon />,
        label: "achievement",
      };
    case "custom_event_unique_code":
      return {
        icon: <FileIcon />,
        label: "redemptionCode",
      };
    default:
      return null;
  }
};

export const getTabWithErrors = (errors: { [key: string]: any }) => {
  const fieldErrorKeys = Object.keys(errors);

  const errorStepMapping: Record<string, CampaignStepsIds> = {
    trigger: CampaignStepsIds.TRIGGER,
    event: CampaignStepsIds.TRIGGER,
    achievementId: CampaignStepsIds.TRIGGER,
    eventCodeAtribute: CampaignStepsIds.TRIGGER,
    generateCodes: CampaignStepsIds.TRIGGER,
    codeGenerator: CampaignStepsIds.TRIGGER,
    translations: CampaignStepsIds.INFO,
    activity: CampaignStepsIds.INFO,
    labels: CampaignStepsIds.INFO,
    visibility: CampaignStepsIds.INFO,
    active: CampaignStepsIds.INFO,
    rules: CampaignStepsIds.RULES,
    transactionItemsFilters: CampaignStepsIds.RULES,
    limits: CampaignStepsIds.LIMITAION,
  };

  return Array.from(
    new Set(
      fieldErrorKeys
        .map((key) => errorStepMapping[key as keyof typeof errorStepMapping])
        .filter(Boolean),
    ),
  );
};
